export type DayMonthType = {month: number; day: number};
